import { theme } from '@lmc/ui-kit'

type ThreeDotsProps = {
  color?: string
  horizontal?: boolean
}

const ThreeDots = ({ color, horizontal }: ThreeDotsProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: horizontal ? 'rotate(-90deg)' : 'none' }} // Apply rotation for vertical alignment
  >
    <g clipPath="url(#clip0_1749_18579)">
      <path
        d="M7.50016 10.0007C7.50016 10.9211 8.24635 11.6673 9.16683 11.6673C10.0873 11.6673 10.8335 10.9211 10.8335 10.0007C10.8335 9.08018 10.0873 8.33398 9.16683 8.33398C8.24636 8.33398 7.50016 9.08018 7.50016 10.0007Z"
        fill={color || theme.color.neutral.color3}
      />
      <path
        d="M7.50016 2.50065C7.50016 3.42113 8.24635 4.16732 9.16683 4.16732C10.0873 4.16732 10.8335 3.42113 10.8335 2.50065C10.8335 1.58018 10.0873 0.833984 9.16683 0.833984C8.24636 0.833984 7.50016 1.58018 7.50016 2.50065Z"
        fill={color || theme.color.neutral.color3}
      />
      <path
        d="M7.50016 17.5007C7.50016 18.4211 8.24635 19.1673 9.16683 19.1673C10.0873 19.1673 10.8335 18.4211 10.8335 17.5007C10.8335 16.5802 10.0873 15.834 9.16683 15.834C8.24636 15.834 7.50016 16.5802 7.50016 17.5007Z"
        fill={color || theme.color.neutral.color3}
      />
    </g>
    <defs>
      <clipPath id="clip0_1749_18579">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(20) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default ThreeDots
